import WhyHisea from './whyHisea';

// 原本是 dynamic(..., { ssr: false }) + react-lazyload。Googlebot 渲染时不滚动页面，
// LazyLoad 不触发，这一块在 Google 眼里始终是空占位（见 GSC 测试实际网址的渲染截图）。
// 块内的 /shipping-return-policy、/warranty、/about-us 三个链接因此拿不到首页内链。
// 图标走 CSS background-image，本身不会阻塞首屏，改为服务端渲染是安全的。
const WhyHiseaLazyLoad = () => {
  return <WhyHisea />;
};

export default WhyHiseaLazyLoad;
